<template>
  <div class="initials-container" :style="{ 'min-width': size + 'px', 'min-height': size + 'px' }" @click="onclick">
    <p v-if="userStore.currentUser">
      {{ userStore.currentUser.name.split(' ')[0].charAt(0).toUpperCase()
      }}{{ userStore.currentUser.name.split(' ')[1].charAt(0).toUpperCase() }}
    </p>
    <p v-else>?</p>
  </div>
</template>

<script>
import { useUserStore } from '@/store/userStore';

export default {
  name: 'ProfileInitials',
  props: {
    size: {
      type: Number,
      default: 40,
    },
    onclick: {
      type: Function,
      default: null,
    },
  },
  setup() {
    const userStore = useUserStore();
    return { userStore };
  },
};
</script>

<style scoped>
.initials-container {
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--button-background);
  margin: 0 10px;
  padding: 3px;
  cursor: pointer;
}
</style>
